import React from "react";

import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Header } from "../component/common/Header";
import { Membership_top } from "../component/membership_page/Membership_top";
import { Membership_main } from "../component/membership_page/Membership_main";
import { Footer } from "../component/common/Footer";
import { Scroll } from "../component/common/Scroll";
import { Scroll_top } from "../component/common/Scroll_top";

export const Membership = () => {
  return (
    <div>
      <main>

        <HelmetProvider>
          <Helmet>
            <title>会員規約 | Fortissimo</title>
          </Helmet>
        </HelmetProvider>
          
        <Header />

        <Membership_top />
        <Membership_main />

        <Footer />

        <Scroll />
        <Scroll_top />

      </main>
    </div>
  );
}